<template>
  <div>
    <van-form @submit="applyFormSubmit">
      <van-field
        v-model="form.username"
        name="username"
        label="姓名"
        placeholder="请填写真实姓名"
        :rules="[
          { required: true, message: '' }
        ]"
      />
      <van-field
        v-model="form.userId"
        name="userId"
        label="身份证"
        placeholder="请填写身份证"
        :rules="[
          { required: true, message: '' },
          { validator: userIdValidator, message: '请输入正确的身份证号码' }
        ]"
      />
      <van-field
        v-model="form.phoneNumber"
        name="phoneNumber"
        label="电话"
        placeholder="请填写电话号码"
        :rules="[
          { required: true, message: '' },
          { validator: phoneNumberValidator, message: '请输入正确的手机号' }
        ]"
      />
      <van-field
        v-model="form.email"
        name="email"
        label="邮箱"
        placeholder="请填写邮箱"
        :rules="[
          { required: true, message: '' },
          { validator: emailValidator, message: '请输入正确格式的邮箱' }
        ]"
      />
      <div style="margin: 20px;">
        <van-button round block type="info" native-type="submit" class="submit-button">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { isIdCard, isPhone, isEmail } from '@/libs/validate'
import { Toast } from "vant";
import util from "../../../libs/util";

export default {
  name: 'ScheDuleApply',
  data() {
    return {
      form: {
        username: '',
        userId: '',
        phoneNumber: '',
        email: ''
      },
      tripId: ''
    }
  },
  computed: { },
  mounted () {
    this.tripId = this.$route.params.id
  },
  created() {
    const shareParam = {
      title: "加入我们，实现价值",
      desc: "卫宁健康2027校园招聘",
      link: process.env.VUE_APP_BASEURL +'#/schedule/list',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  methods: {
    userIdValidator(val) {
      return isIdCard(val)
    },
    phoneNumberValidator(val) {
      return isPhone(val)
    },
    emailValidator(val) {
      return isEmail(val)
    },
    applyFormSubmit() {
      const params = {
        email: this.form.email,
        idcard: this.form.userId,
        mobile: this.form.phoneNumber,
        name: this.form.username,
        trip_id: this.tripId
      }
      this.$api.RECRUIT_TRIP_ENROLL(params).then(() => {
        Toast.success('报名成功');
        this.$router.push('/schedule/list')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  ::v-deep {
    .submit-button {
      background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }

    .van-field__control {
      text-align: right;
    }

    .van-field__error-message {
      text-align: right;
    }

    .van-field__body, .van-field__label span {
      position: relative;
      top: 4px;
    }

    .van-field__label {
      height: 30px;
    }
  }
</style>
